module.exports = __webpack_public_path__ + "img/gongzuozhenshipaizhao.3c448bd4.png";